var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap"},[_c('el-container',{attrs:{"direction":"horizontal"}},[_c('el-aside',{attrs:{"width":_vm.isCollapse ? '80px' : '220px'}},[_c('SiderBar')],1),_vm._v(" "),_c('el-container',[_c('el-header',[_c('Header')],1),_vm._v(" "),_c('NavBar'),_vm._v(" "),_c('el-main',[_c('AppMain')],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a5a288b4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/index.vue
// module id = null
// module chunks = 